define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");

    var template = require("manager-templates/special-occasion/specialOccasionShiftsListView.tmpl");

    var SpecialOccasionShiftItemView = require("manager-views/special-occasion/SpecialOccasionShiftItemView");

    var SpecialOccasionShiftsListView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionShiftsListView = Marionette.CompositeView.extend({
            itemViewContainer: ".shifts-container",
            template: template,
            itemView: SpecialOccasionShiftItemView,
            className: "shifts-list-container",

            ui: {
                addShiftButtonContainer: ".add-shift",
                shiftsContainer: ".shifts-container"
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function () {
                this._onRender();
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.specialOccasionEventModel = options.specialOccasionEventModel;
                this.container = _.has(options, "container") ? options.container : null;
                this.itemViewOptions = {channel: options.channel, specialOccasionEventModel: this.specialOccasionEventModel};
            },

            _onRender: function() {
                this._bindEvents();

                this._manageSingleItemState();

                if (!_.isNull(this.container)) {
                    this.container.append(this.$el);
                }
            },

            _bindEvents: function () {
                this.listenTo(this.collection, "add", this._manageSingleItemState);
                this.listenTo(this.collection, "remove", this._manageSingleItemState);
                this.listenTo(this.channel.vent, "SpecialOccasionShiftItemView:shift:delete", this._deleteShift);
            },

            //sets the class "single-item" when 'x' should not be displayed, and removes it otherwise
            _manageSingleItemState: function () {
                var singleItem = (this.collection.size() === 1);
                this.ui.shiftsContainer.toggleClass("single-item", singleItem);
            },

            _deleteShift: function(shiftModel){
                if (this.collection.size() > 1) {
                    this.channel.trigger("SpecialOccasionShiftsListView:shift:delete", shiftModel, this.specialOccasionEventModel);
                }
            }
        });
    }


    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionShiftsListView;
});
